import React from 'react';
import { Zap, Moon, Sun, Crown, Menu, Layers } from 'lucide-react';
import { Logo } from './Logo';

export const TopHeader = ({
  onOpenQuiz,
  onOpenFlashcards,
  onOpenPremium,
  theme,
  onToggleTheme,
  onToggleSidebar,
  onLogoClick,
}) => {
  return (
    <header
      className="h-[60px] shrink-0 border-b border-border bg-card/60 glass flex flex-nowrap items-center justify-between gap-1 px-2 sm:px-3"
      data-testid="top-header"
    >
      <div className="flex flex-nowrap items-center gap-1 sm:gap-2 min-w-0">
        <button
          onClick={onToggleSidebar}
          data-testid="sidebar-toggle-btn"
          className="w-9 h-9 rounded-full bg-secondary/60 border border-border hover:border-mint/40 flex items-center justify-center transition"
          aria-label="Toggle sidebar"
        >
          <Menu className="w-4 h-4" />
        </button>
        <button
          onClick={onLogoClick}
          data-testid="header-logo-btn"
          className="flex items-center gap-2 min-w-0 hover:opacity-80 transition"
          title="Start new chat"
        >
          <Logo size="sm" testId="brahmastra-logo-header" />
          <span className="hidden sm:inline text-[14.5px] font-semibold tracking-tight truncate">
            Brahmastra <span className="text-mint">AI</span>
          </span>
        </button>
        <button
          onClick={onOpenQuiz}
          data-testid="take-quiz-btn"
          className="ml-1 inline-flex items-center gap-1 pl-2 pr-2.5 py-1.5 rounded-full text-[11px] font-semibold bg-mint/15 text-mint border border-mint/30 hover:bg-mint/25 hover:border-mint/60 transition glow-mint shrink-0"
        >
          <Zap className="w-3.5 h-3.5" />
          <span className="hidden sm:inline">Mini Quiz</span>
          <span className="sm:hidden">Quiz</span>
        </button>
        <button
          onClick={onOpenFlashcards}
          data-testid="open-flashcards-btn"
          className="inline-flex items-center gap-1 pl-2.5 pr-2.5 py-1.5 rounded-full text-[11px] font-semibold bg-bblue/15 text-bblue border border-bblue/30 hover:bg-bblue/25 hover:border-bblue/60 transition shrink-0"
        >
          <Layers className="w-3.5 h-3.5" />
          <span className="hidden sm:inline">Flashcards</span>
          <span className="sm:hidden">Cards</span>
        </button>
      </div>

      <div className="flex flex-nowrap items-center gap-1">
        <button
          onClick={onOpenPremium}
          data-testid="header-premium-btn"
          className="inline-flex items-center justify-center gap-0.5 px-2.5 py-1.5 rounded-full text-[11px] sm:text-[12px] font-semibold bg-gradient-to-r from-mint/15 to-bblue/15 text-mint border border-mint/30 hover:from-mint/25 hover:to-bblue/25 transition shrink-0"
          aria-label="Premium"
        >
          <Crown className="w-3.5 h-3.5" />
          <span className="hidden sm:inline">Prime</span>
        </button>
        <button
          onClick={onToggleTheme}
          data-testid="theme-toggle"
          className="w-9 h-9 rounded-full bg-secondary/60 border border-border hover:border-mint/40 hover:text-mint transition flex items-center justify-center"
          aria-label="Toggle theme"
        >
          {theme === 'dark' ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
        </button>
      </div>
    </header>
  );
};

export default TopHeader;
